
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reports/create/account",
      function () {
        return require("private-next-pages/reports/create/account.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reports/create/account"])
      });
    }
  